export enum SocialSignInMethods {
    Redirect = 1, PopUp, ALL
}